import React from 'react';

const JarIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M8 3h8M9 3v3.342c0 .5-.151.99-.43 1.402L5.24 12.4A3 3 0 004.5 14.5V18a3 3 0 003 3h9a3 3 0 003-3v-3.5c0-.746-.266-1.466-.74-2.1l-3.33-4.656A2.25 2.25 0 0115 6.342V3M6 15h12" />
  </svg>
);

const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
  </svg>
);

// Panel „Cena i gramatura” – wiersze z wariantami opakowania (słoik / gramatura /
// cena) oraz przycisk kontaktu. Dopóki sklep nie ma koszyka, zamówienie
// składa się telefonicznie lub mailowo.
const ProductPrice = React.memo(function ProductPrice({ options }) {
  return (
    <aside className="detail-price">
      <h3 className="detail-price-title">Cennik</h3>
      <ul className="detail-price-list">
        {options.map((opt) => (
          <li key={opt.grams} className="detail-price-row">
            <span className="detail-price-label">
              <JarIcon />
              {opt.grams} g
            </span>
            <span className="detail-price-value">{opt.price} zł</span>
          </li>
        ))}
      </ul>
      <a href="tel:+48 123 456 678" className="detail-cta">
        <PhoneIcon />
        Zamów telefonicznie
      </a>
    </aside>
  );
});

export default ProductPrice;